export default __webpack_public_path__ + "static/media/italianhomemade.a3fb6e81.jpeg";